/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import classNames from 'classnames';
import { ICheckoutGooglePayProps } from './checkout-google-pay.props.autogenerated';
import { ICheckoutGooglePayData } from './checkout-google-pay.data';

export interface ICheckoutGooglePayViewProps extends ICheckoutGooglePayProps<{}> {
    alert?: React.ReactNode;
    className?: string;
    checkoutGooglePay: IModuleProps;
}

export interface ICheckoutGooglePayModuleProps extends ICheckoutGooglePayProps<ICheckoutGooglePayData> {}

interface ICheckoutGooglePayState {
    errorMessage?: string;
}

/**
 *
 * CheckoutGooglePay component
 * @extends {React.Component<ICheckoutGooglePayModuleProps, ICheckoutGooglePayState>}
 */
export class CheckoutGooglePay extends React.Component<ICheckoutGooglePayModuleProps, ICheckoutGooglePayState> {
    private readonly moduleClassName: string = 'ms-checkout-google-pay';

    public constructor(props: ICheckoutGooglePayProps<ICheckoutGooglePayData>) {
        super(props);
    }

    public render(): JSX.Element | null {
        const {
            config: { className }
        } = this.props;

        const viewProps: ICheckoutGooglePayViewProps = {
            ...this.props,
            ...this.state,
            className,
            checkoutGooglePay: {
                moduleProps: this.props,
                className: classNames(this.moduleClassName, className)
            }
        };

        return this.props.renderView(viewProps);
    }
}

export default CheckoutGooglePay;
